import React, { FC, useEffect, useState } from "react";
import {
  Edit,
  EditProps,
  FormTab,
  TabbedForm,
  useEditController,
} from "react-admin";
import { Prize } from "../../types/prize";
import DiscountAndTickets from "../common/discount/DiscountTickets";
import DocumentTitle from "../common/documentTitle/DocumentTitle";
import PrizeGeneralForm from "../lifestylePrizes/PrizeGeneralForm";
import FixedOddsToolbar from "./FixedOddsToolbar";
import { useSelector } from "react-redux";
import { CreditProps } from "../common/generalPickersBlocks/credits/CreditsPickerComponent";

const FixedOddsEdit: FC<EditProps> = (props) => {
  const controllerProps = useEditController<Prize>(props);
  const stateApp = useSelector((state) => state);
  const isCopy = stateApp.property.isNew;

  const [state, setState] = useState({
    isCash: false,
    isPercent: false,
  });

  const [errors, setError] = useState({
    imagesError: false,
    discountFillError: false,
    countdownError: false,
  });

  const [isDiscountValidate, setIsDiscountValidate] = useState(false);

  const [datesValue, setDatesValue] = useState<{
    startDateValue: Date | string;
    endDateValue: Date | string;
  }>({
    startDateValue: new Date(),
    endDateValue: new Date("2031-01-18T19:55:00.000+00:00"),
  });

  const [countdownDatesValue, setCountdownDatesValue] = useState<{
    startDateValue: Date | string;
    endDateValue: Date | string;
  }>({
    startDateValue: new Date(),
    endDateValue: new Date("2031-01-18T19:55:00.000+00:00"),
  });

  const [creditDateType, setCreditDateType] = useState<string>("allDate");

  const handleChangeCreditsDateType = (e: any) => {
    setCreditDateType(e.currentTarget.value);
  };

  const [stateCredits, setCredits] = useState<Array<CreditProps>>([
    {
      id: "1",
      count: 20,
      percent: 30,
    },
  ]);

  useEffect(() => {
    if (controllerProps.record) {
      if (controllerProps.record.creditsRates)
        setCredits(controllerProps.record.creditsRates);
      setDoesCreditsActive(controllerProps.record.isCreditsActive);
      setDatesValue({
        startDateValue:
          (controllerProps.record.creditsStartDate &&
            new Date(controllerProps.record.creditsStartDate)) ||
          new Date(),
        endDateValue:
          (controllerProps.record.creditsEndDate &&
            new Date(controllerProps.record.creditsEndDate)) ||
          new Date("2031-01-18T19:55:00.000+00:00"),
      });
      setCountdownDatesValue({
        startDateValue:
          (controllerProps.record.startAt &&
            new Date(controllerProps.record.startAt)) ||
          new Date(),
          endDateValue:
          (controllerProps.record.endsAt &&
            new Date(controllerProps.record.endsAt)) ||
          new Date("2031-01-18T19:55:00.000+00:00"),
      })
      if (controllerProps.record.isCreditsPermanent) {
        setCreditDateType("allDate");
      } else {
        setCreditDateType("date");
      }
    }
  }, [controllerProps.record]);

  const [isActiveCredits, setDoesCreditsActive] = useState<boolean>(false);

  const handleChangeCreditsStatus = () => {
    setDoesCreditsActive(!isActiveCredits);
  };

  const handleSetCredits = (creditsArr: Array<CreditProps>) => {
    setCredits(creditsArr);
  };
  const handleSetDateValue = (value: string, dateName: string) => {
    setDatesValue({
      ...datesValue,
      [dateName]: value,
    });
  };

  const handleDiscountFillError = (error: boolean) => {
    setError({ ...errors, discountFillError: error });
  };

  const handleImagesError = (error: boolean) => {
    setError({ ...errors, imagesError: error });
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setState({ ...state, [event.currentTarget.name]: checked });
  };

  const setPercent = () => {
    setState({ ...state, isPercent: false });
  };

  const setCash = () => {
    setState({ ...state, isCash: false });
  };
  const handleSetCountdownError = (error: boolean) => {
    setError({ ...errors, countdownError: error });
  };
  const setCountdown = (name: string, value: string) => {
    setCountdownDatesValue({ ...countdownDatesValue, [name]: value });
  };
  return (
    <>
      <DocumentTitle
        core="Prize"
        secondary="Fixed Odds"
        purpose={isCopy ? "Copy" : "Edit"}
        appointment="Fixed Odd "
      />
      <Edit {...props}>
        <TabbedForm
          className="general-tab"
          toolbar={FixedOddsToolbar(
            props,
            false,
            handleImagesError,
            handleDiscountFillError,
            setIsDiscountValidate,
            handleSetCountdownError,
            {
              creditsArr: stateCredits,
              dateType: creditDateType,
              creditsStartDate: datesValue.startDateValue,
              creditsEndDate: datesValue.endDateValue,
              creditsStatus: isActiveCredits,
            },
            countdownDatesValue.startDateValue,
            countdownDatesValue.endDateValue,
            controllerProps.record
          )}
        >
          <FormTab label="General">
            <PrizeGeneralForm
              record={controllerProps.record}
              isShow={false}
              isPrize={false}
              imagesError={errors.imagesError}
              setCountdown={setCountdown}
              countdownStartDate={countdownDatesValue.startDateValue}
              countdownEndDate={countdownDatesValue.endDateValue}
            />
          </FormTab>
          <FormTab label="Discount & tickets">
            <DiscountAndTickets
              entity={controllerProps.record}
              isShow={false}
              ticketPrice={controllerProps.record?.price || 0}
              discountSource="discountCategory"
              isCash={state.isCash}
              isPercent={state.isPercent}
              handleChange={handleChange}
              removePercent={setPercent}
              removeCash={setCash}
              discountFillError={errors.discountFillError}
              isOdds={true}
              isValidate={isDiscountValidate}
              handleChangeCreditsStatus={handleChangeCreditsStatus}
              handleChangeCreditsDateType={handleChangeCreditsDateType}
              handleSetCredits={handleSetCredits}
              isActiveCredits={isActiveCredits}
              credits={stateCredits}
              handleSetDateValue={handleSetDateValue}
              creditDateType={creditDateType}
              creditsStartDateValue={datesValue.startDateValue}
              creditsEndDateValue={datesValue.endDateValue}
              competition="fixedOdds"
            />
          </FormTab>
        </TabbedForm>
      </Edit>
    </>
  );
};

export default FixedOddsEdit;
